import { OptionDto } from "@/dtos";
import { TypeOperation } from "@/helpers/types";

const historicOperationOptions = [
    { label: 'Creación', value: TypeOperation.CREATE as any }, 
    { label: 'Actualización', value: TypeOperation.UPDATE as any },
    { label: 'Actualización Servidor', value: TypeOperation.UPDATE_SERVER as any },
    { label: 'Eliminación', value: TypeOperation.DELETE as any },
] as OptionDto[];

export const getHistoricOperationOptions = (): OptionDto[] => {
    return historicOperationOptions;
}

export const getHistoricOperation = (operation: TypeOperation): OptionDto => {
    return historicOperationOptions.find(x => x.value == operation as any) ?? historicOperationOptions[0];
}
